/**
 * Aufzählungen von Änderungstypen
 */
export enum changesTypes {
    deleted = "(gelöscht)",
    inserted = "(neuer Eintrag)",
    modified = "(geändert)",
    rollback = "(rollback)"
}
